import React from 'react';
import CategoryDropdown from './CategoryDropdown';

const SearchBar = ({ searchTerm, setSearchTerm, category, setCategory }) => {
  return (
    <div className="search-panel">
      <div className="search-input-container">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search websites..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button className="clear-search" onClick={() => setSearchTerm('')}>✕</button>
        )}
      </div>
      
      <CategoryDropdown category={category} setCategory={setCategory} />
    </div>
  );
};

export default SearchBar;